import React from 'react';
import loadableComponent from 'react-loadable';

interface ILazyComponent {
  preload(): Promise<any>;
}

function dynamic<P>(
  importFn: () => Promise<
    React.ComponentType<P> | { default: React.ComponentType<P> }
  >,
): React.ComponentType<P> & ILazyComponent {
  const LazyComponent: any = loadableComponent({
    loader: importFn,
    loading: () => <div>{/* Loading...*/}</div>,
  });

  LazyComponent.preload = () => importFn();

  return LazyComponent;
}

export { ILazyComponent };

export default dynamic;
